export default "__VITE_ASSET__51a771fd__"